export default {
    energyStatistics_00001: "From battery",
    energyStatistics_00002: "From grid",
    energyStatistics_00003: "Trend of electricity consumed by EV",
    energyStatistics_00004: "Revenue & cost trends",
    energyStatistics_00005: "Total income of EV charging",
    energyStatistics_00006: "Battery charged",
    energyStatistics_00007: "Analysis",
    energyStatistics_00008: "Cost of grid",
    energyStatistics_00009: "Cost of battery charging",
    energyStatistics_00010: "Revenue",
    energyStatistics_00011: "Electricity consumed by EV",
    energyStatistics_00012: "Electricity",
    energyStatistics_00013: "Profit",
    energyStatistics_00014: "Revenue & cost",
    energyStatistics_00015: "Analysis",
    energyStatistics_00016: "",
   
} 